module.exports = __webpack_public_path__ + "img/music_013.8e94066c.png";